import React from 'react'

import { ControlButton } from 'live/components/ui/CardContainer'
import i18n from 'live/services/i18n'

import { FieldSetFooter, FieldSetStyledContainer } from './styles'

type FieldsetProps = {
    title: string
    onSubmit?: (event: React.FormEvent<HTMLFormElement>) => void
    toggleEdit?: () => void
    onCancel?: () => void
    disabled?: boolean
    editing?: boolean
    customControls?: JSX.Element
    withFieldset?: boolean
    displayButton?: boolean
}

export const Fieldset: React.FC<FieldsetProps> = props => {
    const {
        children,
        title,
        toggleEdit,
        onSubmit,
        onCancel,
        disabled,
        editing,
        customControls,
        withFieldset = true,
        displayButton = true
    } = props

    return (
        <form onSubmit={onSubmit} style={{ marginTop: 24 }}>
            <FieldSetStyledContainer
                editing={editing}
                title={title}
                renderControls={() => {
                    if (editing) {
                        return <></>
                    }

                    if (customControls) {
                        return customControls
                    }

                    return (
                        <div>
                            <ControlButton>
                                <i
                                    style={displayButton ? {} : { display: 'none' }}
                                    onClick={toggleEdit}
                                    className="far fa-edit"
                                />
                            </ControlButton>
                        </div>
                    )
                }}
            >
                {withFieldset ? <fieldset disabled={!editing}>{children}</fieldset> : children}

                {editing && (
                    <FieldSetFooter>
                        <div className="action-buttons">
                            <button type="submit" className="btn btn-primary" disabled={disabled}>
                                {i18n('Save')}
                            </button>
                            <div className="or">{i18n('or')}</div>
                            <button className="btn btn-link" onClick={onCancel}>
                                {i18n('Cancel')}
                            </button>
                        </div>
                    </FieldSetFooter>
                )}
            </FieldSetStyledContainer>
        </form>
    )
}
